import { render, staticRenderFns } from "./SupplierImportedProductPackages.vue?vue&type=template&id=7c87b2d5&"
import script from "./SupplierImportedProductPackages.vue?vue&type=script&lang=js&"
export * from "./SupplierImportedProductPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports